import { render, staticRenderFns } from "./InboxContactPicker.vue?vue&type=template&id=2472906a"
import script from "./InboxContactPicker.vue?vue&type=script&lang=js"
export * from "./InboxContactPicker.vue?vue&type=script&lang=js"
import style0 from "./InboxContactPicker.vue?vue&type=style&index=0&id=2472906a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports